import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'statustext'
})

export class StatusTextPipe implements PipeTransform {

    constructor(
        private translateService: TranslateService
    ) {

    }
    /** in base al parmetro passato si setta la traduzione instantea e si setta lo status con la traduzione richiesta
     * @param  {any} value
     * @returns black
     */
    transform(value: any): string {
        let status: string;
        let translate: string;
        if (value != null) {
            switch (value) {
                case "private":
                    translate = this.translateService.instant('core.status.experienceprivate');
                    status = '<h3 style="color:grey"><i class="fas fa-lock" style="color:black"></i>'+ translate +'</h3>';
                    break;

                case "public":
                    translate = this.translateService.instant('core.status.experiencepublic');
                    status = '<h3 style="color:green"><i class="fas fa-globe" style="color:black"></i>'+ translate +'</h3>';
                    break;

                case "archived":
                    translate = this.translateService.instant('core.status.experiencearchived');
                    status = '<h3 style="color:black"><i class="fas fa-trash" style="color:black"></i>'+ translate +'</h3>';
                    break;

                case "delete":
                    translate = this.translateService.instant('core.status.experiencedelete');
                    status = '<h3 style="color:black"><i class="fas fa-times" style="color:black"></i>'+ translate +'</h3>';
                    break;

                case "wait":
                    translate = this.translateService.instant('core.status.experiencewaiting');
                    status = '<h3 style="color:#ffbd46"><i class="fas fa-pause" style="color:black"></i>'+ translate +'</h3>';
                    break;
            }
        }
        return status;
    }
}